import * as Cesium from 'cesium';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/_main.scss';
import AppLayout from './views/AppLayout';
import { LegendDrawerProvider } from './context/MapLegendContext';
import { LayerPropertiesProvider } from './context/LayerPropertiesContext';
import { MapProvider } from './context/MapContext';
import { SketchPropertiesProvider } from './context/SketchPropertiesContext';
import { AuthProvider } from './context/AuthContext';

Cesium.Ion.defaultAccessToken = import.meta.env.VITE_APP_CESIUM_ACCESS_TOKEN as string;

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <MapProvider>
          <LegendDrawerProvider>
            <LayerPropertiesProvider>
              <SketchPropertiesProvider>
                <AppLayout />
              </SketchPropertiesProvider>
            </LayerPropertiesProvider>
          </LegendDrawerProvider>
        </MapProvider>
      </Router>
    </AuthProvider>
  );
};

export default App;
